import { defineComponent as _defineComponent } from 'vue'
import { PaibanTaskAction, PaibanTaskRow, PaibanTaskStatusEnum } from '../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-paiban-task-operation-cell',
  props: {
    record: null
  },
  emits: ["action"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'action', type: PaibanTaskAction, record: PaibanTaskRow): void
}), expose: any, slots: any, attrs: any }) {





function canOpenPlan(record: PaibanTaskRow): boolean {
  return (
    record.taskStatus === PaibanTaskStatusEnum.COMPLETED &&
    Boolean(record.request_url)
  )
}

return { __sfc: true,emit, canOpenPlan, PaibanTaskStatusEnum }
}

})